import InjectedSelect from "../injected-select.jsx";
import { Checkbox } from "material-ui";
import React from "react";


class BoxOfficePosFilter extends React.Component {

  getStyles() {
    return {
      filterContainer: {
        display: "flex"
      },
      venueSelectorContainer: {
        display: "flex",
        backgroundColor: "rgba(0,0,0,0.1)",
        padding: "10px 20px",
        borderRadius: 5,
      },
    };
  }

  render() {
    const styles = this.getStyles();

    return (
      <div style={styles.venueSelectorContainer}>
          <span style={{ marginRight: 10 }}>
            <span
              className="Select-control flex items-center"
              style={{ width: 175, boxSizing: "border-box" }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
                className="flex-shrink-0 w-4 h-4 ml-2 mr-1 -my-2"
              >
                <path
                  fillRule="evenodd"
                  d="M9 3.5a5.5 5.5 0 100 11 5.5 5.5 0 000-11zM2 9a7 7 0 1112.452 4.391l3.328 3.329a.75.75 0 11-1.06 1.06l-3.329-3.328A7 7 0 012 9z"
                  clipRule="evenodd"
                />
              </svg>
              <input
                className="BoxOffice--PosMode--SearchInput flex-1 min-w-0"
                type="text"
                value={this.props.filterText}
                onChange={e => this.props.updateFilterText(e.target.value)}
                placeholder="Search events"
                style={{
                  border: "none",
                  outline: "none"
                }}
              />
              {this.props.filterText ? (
                <span
                  className="Select-clear-zone flex-shrink-0"
                  onClick={() => {
                    this.props.updateFilterText("");
                  }}
                >
                  <span className="Select-clear">×</span>
                </span>
              ) : null}
            </span>
          </span>
        <span style={{ flex: 1 }}>
            <InjectedSelect
              autosize={false}
              value={this.props.posConfig.selectedVenueId}
              style={{ maxWidth: 175 }}
              placeholder="All venues"
              type="venues"
              labelFormatter={v => `${v.name}`}
              eventBucketId={this.props.orderData.event_bucket}
              sortFunction={(a, b) => a.label.localeCompare(b.label)}
              onChange={selectedVenueId => {
                this.props.updatePosConfig({
                  ...this.props.posConfig,
                  selectedVenueId
                });
              }}
            />
          </span>
        <span>
            <Checkbox
              label="Today only"
              style={{ width: 95, marginLeft: 20 }}
              iconStyle={{ marginRight: 4 }}
              labelStyle={{ width: "100%" }}
              checked={this.props.posConfig.todayOnly}
              onCheck={e => {
                this.props.updatePosConfig({
                  ...this.props.posConfig,
                  todayOnly: e.target.checked
                });
              }}
            />
          </span>
        <span>
            <Checkbox
              label={`Filter by tag${
                this.props.posConfig.filterByTag ? "s:" : ""
              }`}
              style={{
                width: this.props.posConfig.filterByTag ? 120 : 102,
                marginLeft: 20
              }}
              iconStyle={{ marginRight: 4 }}
              labelStyle={{ width: "100%" }}
              checked={this.props.posConfig.filterByTag}
              onCheck={e => {
                this.props.updatePosConfig({
                  ...this.props.posConfig,
                  filterByTag: e.target.checked
                });
              }}
            />
          </span>
        {this.props.posConfig.filterByTag ? (
          <InjectedSelect
            autosize={false}
            multi
            value={this.props.posConfig.selectedTagIds || []}
            style={{
              width: 200
            }}
            placeholder="All tags"
            type="tags"
            labelFormatter={v => `${v.name}`}
            eventBucketId={this.props.orderData.event_bucket}
            sortFunction={(a, b) => a.label.localeCompare(b.label)}
            onChange={selectedTagIds => {
              this.props.updatePosConfig({
                ...this.props.posConfig,
                selectedTagIds
              });
            }}
          />
        ) : null}
      </div>
    )
  }
}

export default BoxOfficePosFilter;


// WEBPACK FOOTER //
// ./src/app/components/partials/box-office/box-office-pos-filter.jsx